module.exports = __webpack_public_path__ + "img/czjyJtcs.addc2531.png";